import { render, staticRenderFns } from "./SupportableDateSetting.vue?vue&type=template&id=6e063ae0&scoped=true&"
import script from "./SupportableDateSetting.vue?vue&type=script&lang=ts&"
export * from "./SupportableDateSetting.vue?vue&type=script&lang=ts&"
import style0 from "./SupportableDateSetting.vue?vue&type=style&index=0&id=6e063ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e063ae0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VRow,VSpacer})
